import React, { useState, useRef, useEffect } from "react";
import "./news.css?v=1.0";

const PostDescription = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      // Vérifie si le texte dépasse 3 lignes
      setIsTruncated(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, [text]);

  return (
    <div>
      <p
        ref={textRef}
        className={`post-description ${isExpanded ? "expanded" : ""}`}
      >
        {text}
      </p>

      {isTruncated && !isExpanded && (
        <button onClick={() => setIsExpanded(true)} className="see-more-btn">
          Voir plus
        </button>
      )}
      
      {isExpanded && (
        <button onClick={() => setIsExpanded(false)} className="see-less-btn">
          Voir moins
        </button>
      )}
    </div>
  );
};

export default PostDescription;
